import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  centerDiv: {
    textAlign: "center",
  },
}));

export default useStyles;
